// extracted by mini-css-extract-plugin
export default {"layout":"tabPages_layout__dJYq-","layoutContent":"tabPages_layoutContent__f-dcN","layoutSider":"tabPages_layoutSider__hhY0V","siderMenu":"tabPages_siderMenu__950Qi","mainContentWrapper":"tabPages_mainContentWrapper__To1wT","mainContent":"tabPages_mainContent__70TJ6"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"layout\":\"tabPages_layout__dJYq-\",\"layoutContent\":\"tabPages_layoutContent__f-dcN\",\"layoutSider\":\"tabPages_layoutSider__hhY0V\",\"siderMenu\":\"tabPages_siderMenu__950Qi\",\"mainContentWrapper\":\"tabPages_mainContentWrapper__To1wT\",\"mainContent\":\"tabPages_mainContent__70TJ6\"}";
        // 1793842494679
        var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  